/* eslint-disable no-param-reassign */
import { Component, registerComponent } from 'js/component.js';

class ComboboxDatePicker extends Component {

    constructor(cdp) {
        super();
        this.filterableList = document.querySelector('.filterable-listing__container');
        this.cfListDatepickers = cdp.querySelector('.content-fragment-list__datepickers');
        this.buttonLabel = 'Date';
        this.monthLabels = [];
        this.monthLanguageLabels = cdp.querySelector('.filter-facet__month-labels');
        for (let i = 0; i < 12; i += 1) {
            this.monthLabels.push(this.monthLanguageLabels.children[i].textContent);
        }
        this.comboboxNode = cdp.querySelector('#textfield');
        this.bigButton = cdp.querySelector('#bigButton');
        this.dialogNode = cdp.querySelector('[role="dialog"]');
        this.calendarField = cdp.querySelector('#calendarField').children[0].textContent;
        this.monthYearNode = this.dialogNode.querySelector('.month-year');
        this.prevMonthNode = this.dialogNode.querySelector('.prev-month');
        this.nextMonthNode = this.dialogNode.querySelector('.next-month');
        this.tbodyNode = this.dialogNode.querySelector('table.dates tbody');
        this.lastRowNode = null;
        this.days = [];
        this.referenceDay = new Date();
        this.preFocusDay = new Date();
        this.focusDay1 = new Date();
        this.focusDay2 = new Date();
        this.firstSelect = false;

        this.monthYearNode.addEventListener('change', this.onJumpMonth.bind(this));
        this.prevMonthNode.addEventListener('click', this.onPreviousMonthButton.bind(this));
        this.nextMonthNode.addEventListener('click', this.onNextMonthButton.bind(this));
        this.bigButton.addEventListener('keydown', this.onComboboxKeyDown.bind(this));
        this.monthYearNode.addEventListener('keydown', this.onMonthYearNode.bind(this));
        this.prevMonthNode.addEventListener('keydown', this.onPreviousMonthButton.bind(this));
        this.nextMonthNode.addEventListener('keydown', this.onNextMonthButton.bind(this));
        this.monthYearNode.setAttribute('tabindex', '-1');
        this.prevMonthNode.setAttribute('tabindex', '-1');
        this.nextMonthNode.setAttribute('tabindex', '-1');
        window.addEventListener('open-date-list', () => this.open());
        window.addEventListener('close-date-list', () => this.firstSelect = false);

        cdp.removeDate = () => {
            if (this.filterableList !== null) {
                this.filterableList.removeAttribute('data-start-pub-date');
                this.filterableList.removeAttribute('data-start-date');
                this.filterableList.removeAttribute('data-end-pub-date');
                this.filterableList.removeAttribute('data-end-date');
            } else if (this.cfListDatepickers !== null) {
                [...this.cfListDatepickers.querySelectorAll('input[type="date"]')].forEach((input) => {
                    input.value = '';
                });
                [...this.cfListDatepickers.querySelectorAll('input[type="date"]')][0].dispatchEvent(new Event('change'));
            }
            this.focusDay1 = new Date();
            this.focusDay2 = new Date();
            this.comboboxNode.textContent = 'Date';
            this.updateGrid();
        };

        // Create Grid of Dates

        this.tbodyNode.innerHTML = '';
        for (let i = 0; i < 6; i += 1) {
            const row = this.tbodyNode.insertRow(i);
            this.lastRowNode = row;
            for (let j = 0; j < 7; j += 1) {
                const cell = document.createElement('td');
                cell.setAttribute('tabindex', '-1');
                cell.addEventListener('click', this.onDayClick.bind(this));
                cell.addEventListener('keydown', this.onDayKeyDown.bind(this));
                cell.textContent = '-1';
                row.appendChild(cell);
                this.days.push(cell);
            }
        }

        // Fill in the month-year header with months and year
        let currentDate = new Date();
        currentDate = currentDate.getFullYear();
        for (let i = (currentDate + 1 - 2011); i >= 0; i -= 1) {
            for (let j = 0; j < 12; j += 1) {
                const option = document.createElement('option');
                option.text = `${this.monthLabels[j]} ${currentDate + 1 - i}`;
                option.value = `${j + 1}-${currentDate + 1 - i}`;
                this.monthYearNode.appendChild(option);
            }
        }
        currentDate = new Date();
        this.monthYearNode.value = `${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;

        this.updateGrid();
        this.close(false);
    }

    isSameDay(day1, day2) {
        return (day1.getFullYear() === day2.getFullYear() && day1.getMonth() === day2.getMonth() && day1.getDate() === day2.getDate());
    }

    // this is responsible for setting all of the dates in the correct spot in the calendar boxes
    updateGrid() {
        let i;
        let flag;
        const rd = this.referenceDay;

        const firstDayOfMonth = new Date(rd.getFullYear(), rd.getMonth(), 1);
        const dayOfWeek = firstDayOfMonth.getDay();

        firstDayOfMonth.setDate(firstDayOfMonth.getDate() - dayOfWeek); // name of variable is misleading--it's the first day in the calendar month box (so it's usually a couple days before the first day of the actual month)

        const d = new Date(firstDayOfMonth);

        for (i = 0; i < this.days.length; i += 1) {
            flag = d.getMonth() !== rd.getMonth();
            this.updateDate(this.days[i], flag, d);
            d.setDate(d.getDate() + 1);

            // Hide last row if all disabled dates
            if (i === 35) {
                if (flag) {
                    this.lastRowNode.style.visibility = 'hidden';
                } else {
                    this.lastRowNode.style.visibility = 'visible';
                }
            }
        }

        this.setFocusDays();
    }

    // this highlights the selected dates in the calendar
    setFocusDays(flag) {
        if (typeof flag !== 'boolean') {
            flag = true;
        }
        const fd1 = this.focusDay1;
        const fd2 = this.focusDay2;
        const { getDayFromDataDateAttribute } = this;

        function checkDay(domNode) {
            const d = getDayFromDataDateAttribute(domNode);

            if(d.getMonth() !== this.referenceDay.getMonth()) {
                return;
            }

            domNode.setAttribute('tabindex', '-1');
            if(this.isSameDay(d, fd1) && !this.isSameDay(d, fd2)) {
                const cellChildRelative = document.createElement('div');
                const cellChildAbsolute = document.createElement('div');
                cellChildRelative.classList.add('td-background-relative-start');
                cellChildAbsolute.classList.add('td-background-absolute-start');
                cellChildRelative.appendChild(cellChildAbsolute);
                domNode.appendChild(cellChildRelative);
            } else if(this.isSameDay(d, fd2) && !this.isSameDay(d, fd1)) {
                const cellChildRelative = document.createElement('div');
                const cellChildAbsolute = document.createElement('div');
                cellChildRelative.classList.add('td-background-relative-end');
                cellChildAbsolute.classList.add('td-background-absolute-end');
                cellChildRelative.appendChild(cellChildAbsolute);
                domNode.appendChild(cellChildRelative);
            } else if(d > fd1 && d < fd2) {
                const cellChildRelative = document.createElement('div');
                const cellChildAbsolute = document.createElement('div');
                cellChildRelative.classList.add('td-background-relative');
                cellChildAbsolute.classList.add('td-background-absolute');
                cellChildRelative.appendChild(cellChildAbsolute);
                domNode.appendChild(cellChildRelative);
            }
            if(d >= fd1 && d <= fd2) {
                domNode.setAttribute('tabindex', '0');
                domNode.classList.add('selected');
            }
            if(this.isSameDay(d, fd1) && this.isSameDay(d, fd2)) {
                domNode.classList.add('startDate');
                domNode.classList.add('endDate');
            } else if(this.isSameDay(d, fd1)) {
                domNode.classList.add('startDate');
                domNode.classList.remove('endDate');
            } else if(this.isSameDay(d, fd2)) {
                domNode.classList.add('endDate');
                domNode.classList.remove('startDate');
            } else{
                domNode.classList.remove('startDate');
                domNode.classList.remove('endDate');
            }
        }

        this.days.forEach(checkDay.bind(this));
    }

    open() {
        this.monthYearNode.setAttribute('tabindex', '0');
        this.prevMonthNode.setAttribute('tabindex', '0');
        this.nextMonthNode.setAttribute('tabindex', '0');
        this.updateGrid();
    }

    close(flag) {
        if (typeof flag !== 'boolean') {
            flag = true;
        }
        this.firstSelect = false;
        this.days.forEach((element) => {
            element.setAttribute('tabindex', '-1');
        });
        this.monthYearNode.setAttribute('tabindex', '-1');
        this.prevMonthNode.setAttribute('tabindex', '-1');
        this.nextMonthNode.setAttribute('tabindex', '-1');

        this.bigButton.setAttribute('aria-expanded', 'false');
        this.dialogNode.setAttribute('aria-hidden', 'true');
    }

    onNextMonthButton(event) {
        const currentDate = new Date();

        let flag = false;
        switch (event.type) {
        case 'keydown':
            switch (event.key) {
            case 'Esc':
            case 'Escape':
                this.close();
                flag = true;
                break;

            case 'Down':
            case 'ArrowDown':
                this.setPreFocusDay();
                flag = true;
                break;

            case 'Enter':
                if(this.referenceDay.getMonth() < 11 || this.referenceDay.getFullYear() < currentDate.getFullYear() + 1) {
                    this.moveToNextMonth();
                    this.setPreFocusDay(false);
                }
                flag = true;
                break;

            default:
                break;
            }
            break;
        case 'click':
            if(this.referenceDay.getMonth() < 11 || this.referenceDay.getFullYear() < currentDate.getFullYear() + 1) {
                this.moveToNextMonth();
                this.setPreFocusDay(false);
            }
            flag = true;
            break;

        default:
            break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onPreviousMonthButton(event) {
        let flag = false;
        switch (event.type) {
        case 'keydown':
            switch (event.key) {
            case 'Esc':
            case 'Escape':
                this.close();
                flag = true;
                break;

            case 'Down':
            case 'ArrowDown':
                this.setPreFocusDay();
                flag = true;
                break;

            case 'Enter':
                if(this.referenceDay.getMonth() > 0 || this.referenceDay.getFullYear() > 2012) {
                    this.moveToPreviousMonth();
                    this.setPreFocusDay();
                }
                flag = true;
                break;
            default:
                break;
            }

            break;

        case 'click':
            if(this.referenceDay.getMonth() > 0 || this.referenceDay.getFullYear() > 2012) {
                this.moveToPreviousMonth();
                this.setPreFocusDay();
            }
            flag = true;
            break;

        default:
            break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onMonthYearNode(event) {
        let flag = false;
        switch (event.type) {
        case 'keydown':
            switch (event.key) {
            case 'Down':
            case 'ArrowDown':
                this.setPreFocusDay();
                flag = true;
                break;

            default:
                break;
            }

            break;

        default:
            break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onJumpMonth(event) {
        this.jumpToMonth();
        event.stopPropagation();
        event.preventDefault();
    }

    moveToNextMonth() {
        this.referenceDay.setMonth(this.referenceDay.getMonth() + 1);
        this.monthYearNode.value = `${this.referenceDay.getMonth() + 1}-${this.referenceDay.getFullYear()}`;
        this.updateGrid();
    }

    moveToPreviousMonth() {
        this.referenceDay.setMonth(this.referenceDay.getMonth() - 1);
        this.monthYearNode.value = `${this.referenceDay.getMonth() + 1}-${this.referenceDay.getFullYear()}`;
        this.updateGrid();
    }

    jumpToMonth() {
        const nums = this.monthYearNode.value.split('-');
        this.referenceDay.setMonth(nums[0] - 1);
        this.referenceDay.setFullYear(nums[1]);
        this.updateGrid();
    }

    // day methods
    isDayDisabled(domNode) {
        return domNode.classList.contains('disabled');
    }

    getDayFromDataDateAttribute(domNode) {
        const parts = domNode.getAttribute('data-date').split('-');
        // eslint-disable-next-line radix
        return new Date(parts[0], parseInt(parts[1]) - 1, parts[2]);
    }

    updateDate(domNode, disable, day) {
        let d = day.getDate().toString();
        if (day.getDate() <= 9) {
            d = `0${d}`;
        }

        let m = day.getMonth() + 1;
        if (day.getMonth() < 9) {
            m = `0${m}`;
        }

        domNode.setAttribute('tabindex', '-1');
        domNode.classList.remove('selected');
        domNode.removeAttribute('aria-selected');
        domNode.setAttribute('data-date', `${day.getFullYear()}-${m}-${d}`);

        if (disable) {
            domNode.classList.add('disabled');
            domNode.textContent = '';
        } else {
            domNode.classList.remove('disabled');
            domNode.textContent = day.getDate();
        }
    }

    onDayKeyDown(event) {
        let flag = false;

        switch (event.key) {
        case 'Esc':
        case 'Escape':
            this.close();
            break;

        case ' ':
        case 'Enter':
            this.onDayClick(event);
            break;

        case 'Right':
        case 'ArrowRight':
            this.movePreFocusToNextDay();
            flag = true;
            break;

        case 'Left':
        case 'ArrowLeft':
            this.movePreFocusToPreviousDay();
            flag = true;
            break;

        case 'Down':
        case 'ArrowDown':
            this.movePreFocusToNextWeek();
            flag = true;
            break;

        case 'Up':
        case 'ArrowUp':
            this.movePreFocusToPreviousWeek();
            flag = true;
            break;

        case 'PageUp':
            if (event.shiftKey) {
                this.moveToPreviousYear();
            } else {
                this.moveToPreviousMonth();
            }
            this.setPreFocusDay();
            flag = true;
            break;

        case 'PageDown':
            if (event.shiftKey) {
                this.moveToNextYear();
            } else {
                this.moveToNextMonth();
            }
            this.setPreFocusDay();
            flag = true;
            break;

        case 'Home':
            this.movePreFocusToFirstDayOfWeek();
            flag = true;
            break;

        case 'End':
            this.movePreFocusToLastDayOfWeek();
            flag = true;
            break;
        default:
            break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    movePreFocusToDay(day) {
        const d = this.preFocusDay;

        this.preFocusDay = day;

        if (d.getMonth() !== this.preFocusDay.getMonth() || d.getYear() !== this.preFocusDay.getYear()) {
            this.updateGrid();
        }
        this.setPreFocusDay();
    }

    setPreFocusDay(flag) {
        if (typeof flag !== 'boolean') {
            flag = true;
        }

        const fd = this.preFocusDay;
        const { getDayFromDataDateAttribute } = this;

        let hasPreFocusDay = false;

        function checkDay(domNode) {
            const d = getDayFromDataDateAttribute(domNode);

            if (this.isSameDay(d, fd)) {
                if (flag) {
                    domNode.focus();
                    hasPreFocusDay = true;
                }
            }
        }

        this.days.forEach(checkDay.bind(this));

        if(!hasPreFocusDay) {
            this.days[7].focus();
            this.preFocusDay = getDayFromDataDateAttribute(this.days[7]);
        }
    }

    movePreFocusToNextDay() {
        const d = new Date(this.preFocusDay);
        d.setDate(d.getDate() + 1);
        if(d.getMonth() !== this.referenceDay.getMonth()) {
            this.referenceDay.setMonth(this.referenceDay.getMonth() + 1);
            this.monthYearNode.value = `${this.referenceDay.getMonth() + 1}-${this.referenceDay.getFullYear()}`;
        }
        this.movePreFocusToDay(d);
    }

    movePreFocusToPreviousDay() {
        const d = new Date(this.preFocusDay);
        d.setDate(d.getDate() - 1);
        if(d.getMonth() !== this.referenceDay.getMonth()) {
            this.referenceDay.setMonth(this.referenceDay.getMonth() - 1);
            this.monthYearNode.value = `${this.referenceDay.getMonth() + 1}-${this.referenceDay.getFullYear()}`;
        }
        this.movePreFocusToDay(d);
    }

    movePreFocusToNextWeek() {
        const d = new Date(this.preFocusDay);
        d.setDate(d.getDate() + 7);
        if(d.getMonth() !== this.referenceDay.getMonth()) {
            this.referenceDay.setMonth(this.referenceDay.getMonth() + 1);
            this.monthYearNode.value = `${this.referenceDay.getMonth() + 1}-${this.referenceDay.getFullYear()}`;
        }
        this.movePreFocusToDay(d);
    }

    movePreFocusToPreviousWeek() {
        const d = new Date(this.preFocusDay);
        d.setDate(d.getDate() - 7);
        if(d.getMonth() !== this.referenceDay.getMonth()) {
            this.referenceDay.setMonth(this.referenceDay.getMonth() - 1);
            this.monthYearNode.value = `${this.referenceDay.getMonth() + 1}-${this.referenceDay.getFullYear()}`;
        }
        this.movePreFocusToDay(d);
    }

    movePreFocusToFirstDayOfWeek() {
        const d = new Date(this.preFocusDay);
        d.setDate(d.getDate() - d.getDay());
        this.movePreFocusToDay(d);
    }

    movePreFocusToLastDayOfWeek() {
        const d = new Date(this.preFocusDay);
        d.setDate(d.getDate() + (6 - d.getDay()));
        this.movePreFocusToDay(d);
    }

    moveToNextYear() {
        this.preFocusDay.setFullYear(this.preFocusDay.getFullYear() + 1);
        this.updateGrid();
    }

    moveToPreviousYear() {
        this.preFocusDay.setFullYear(this.preFocusDay.getFullYear() - 1);
        this.updateGrid();
    }

    onComboboxKeyDown(event) {
        let flag = false;

        if (event.ctrlKey || event.shiftKey) {
            return;
        }

        switch (event.key) {
        case 'Down':
        case 'ArrowDown':
            this.setPreFocusDay();
            flag = true;
            break;

        case 'Esc':
        case 'Escape':
            if (this.isOpen()) {
                this.close(false);
            }
            this.option = null;
            flag = true;
            break;

        default:
            break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onDayClick(event) {
        if (!this.isDayDisabled(event.currentTarget)) {
            if(!this.firstSelect) {
                this.setComboboxDate(event.currentTarget);
                this.firstSelect = true;
                this.focusDay1 = this.getDayFromDataDateAttribute(event.currentTarget);
                if (this.filterableList !== null) {
                    if(this.calendarField === 'publish-date') {
                        this.filterableList.setAttribute('data-start-pub-date', `${this.focusDay1.getFullYear()}-${this.focusDay1.getMonth() + 1}-${this.focusDay1.getDate()}`);
                    } else {
                        this.filterableList.setAttribute('data-start-date', `${this.focusDay1.getFullYear()}-${this.focusDay1.getMonth() + 1}-${this.focusDay1.getDate()}`);
                    }
                } else if (this.cfListDatepickers !== null) {
                    this.cfListDatepickers.querySelector('input[data-name="start"]').value = `${this.focusDay1.getFullYear()}-${(this.focusDay1.getMonth() + 1).toString().padStart(2, '0')}-${this.focusDay1.getDate().toString().padStart(2, '0')}`;
                    this.cfListDatepickers.querySelector('input[data-name="start"]').dispatchEvent(new Event('change'));
                }
                this.focusDay2 = this.getDayFromDataDateAttribute(event.currentTarget);
                if (this.filterableList !== null) {
                    if(this.calendarField === 'publish-date') {
                        this.filterableList.setAttribute('data-end-pub-date', `${this.focusDay2.getFullYear()}-${this.focusDay2.getMonth() + 1}-${this.focusDay2.getDate()}`);
                    } else {
                        this.filterableList.setAttribute('data-end-date', `${this.focusDay2.getFullYear()}-${this.focusDay2.getMonth() + 1}-${this.focusDay2.getDate()}`);
                    }
                } else if (this.cfListDatepickers !== null) {
                    if (this.focusDay1.getFullYear() !== this.focusDay2.getFullYear() || this.focusDay1.getMonth() !== this.focusDay2.getMonth() || this.focusDay1.getDate() !== this.focusDay2.getDate()) {
                        this.cfListDatepickers.querySelector('input[data-name="end"]').value = `${this.focusDay2.getFullYear()}-${(this.focusDay2.getMonth() + 1).toString().padStart(2, '0')}-${this.focusDay2.getDate().toString().padStart(2, '0')}`;
                    } else {
                        this.cfListDatepickers.querySelector('input[data-name="end"]').value = '';
                    }
                    this.cfListDatepickers.querySelector('input[data-name="end"]').dispatchEvent(new Event('change'));
                }
                this.updateGrid();
                window.dispatchEvent(new CustomEvent('apply-date-filter-selections'));
                window.dispatchEvent(new CustomEvent('update-date-pill', {
                    detail: {
                        addDate: {
                            title: `${this.monthLabels[this.focusDay1.getMonth()]} ${this.focusDay1.getDate()} - ${this.monthLabels[this.focusDay2.getMonth()]} ${this.focusDay2.getDate()}`,
                            path: 'date-range'
                        }
                    }
                }));
            } else if(this.focusDay1 <= this.getDayFromDataDateAttribute(event.currentTarget)) {
                this.focusDay2 = this.getDayFromDataDateAttribute(event.currentTarget);
                if (this.filterableList !== null) {
                    if(this.calendarField === 'publish-date') {
                        this.filterableList.setAttribute('data-end-pub-date', `${this.focusDay2.getFullYear()}-${this.focusDay2.getMonth() + 1}-${this.focusDay2.getDate()}`);
                    } else {
                        this.filterableList.setAttribute('data-end-date', `${this.focusDay2.getFullYear()}-${this.focusDay2.getMonth() + 1}-${this.focusDay2.getDate()}`);
                    }
                } else if (this.cfListDatepickers !== null) {
                    if (this.focusDay1.getFullYear() !== this.focusDay2.getFullYear() || this.focusDay1.getMonth() !== this.focusDay2.getMonth() || this.focusDay1.getDate() !== this.focusDay2.getDate()) {
                        this.cfListDatepickers.querySelector('input[data-name="end"]').value = `${this.focusDay2.getFullYear()}-${(this.focusDay2.getMonth() + 1).toString().padStart(2, '0')}-${this.focusDay2.getDate().toString().padStart(2, '0')}`;
                    } else {
                        this.cfListDatepickers.querySelector('input[data-name="end"]').value = '';
                    }
                    this.cfListDatepickers.querySelector('input[data-name="end"]').dispatchEvent(new Event('change'));
                }
                this.setComboboxDate2();
                this.updateGrid();
                this.close();
                this.firstSelect = false;
                window.dispatchEvent(new CustomEvent('apply-date-filter-selections'));
                window.dispatchEvent(new CustomEvent('update-date-pill', {
                    detail: {
                        addDate: {
                            title: `${this.monthLabels[this.focusDay1.getMonth()]} ${this.focusDay1.getDate()} - ${this.monthLabels[this.focusDay2.getMonth()]} ${this.focusDay2.getDate()}`,
                            path: 'date-range'
                        }
                    }
                }));
            } else if(this.focusDay1 > this.getDayFromDataDateAttribute(event.currentTarget)) {
                this.focusDay2 = this.focusDay1;
                this.focusDay1 = this.getDayFromDataDateAttribute(event.currentTarget);
                if (this.filterableList !== null) {
                    if(this.calendarField === 'publish-date') {
                        this.filterableList.setAttribute('data-start-pub-date', `${this.focusDay1.getFullYear()}-${this.focusDay1.getMonth() + 1}-${this.focusDay1.getDate()}`);
                    } else {
                        this.filterableList.setAttribute('data-start-date', `${this.focusDay1.getFullYear()}-${this.focusDay1.getMonth() + 1}-${this.focusDay1.getDate()}`);
                    }
                    if(this.calendarField === 'publish-date') {
                        this.filterableList.setAttribute('data-end-pub-date', `${this.focusDay2.getFullYear()}-${this.focusDay2.getMonth() + 1}-${this.focusDay2.getDate()}`);
                    } else {
                        this.filterableList.setAttribute('data-end-date', `${this.focusDay2.getFullYear()}-${this.focusDay2.getMonth() + 1}-${this.focusDay2.getDate()}`);
                    }
                } else if (this.cfListDatepickers !== null) {
                    this.cfListDatepickers.querySelector('input[data-name="start"]').value = `${this.focusDay1.getFullYear()}-${(this.focusDay1.getMonth() + 1).toString().padStart(2, '0')}-${this.focusDay1.getDate().toString().padStart(2, '0')}`;
                    if (this.focusDay1.getFullYear() !== this.focusDay2.getFullYear() || this.focusDay1.getMonth() !== this.focusDay2.getMonth() || this.focusDay1.getDate() !== this.focusDay2.getDate()) {
                        this.cfListDatepickers.querySelector('input[data-name="end"]').value = `${this.focusDay2.getFullYear()}-${(this.focusDay2.getMonth() + 1).toString().padStart(2, '0')}-${this.focusDay2.getDate().toString().padStart(2, '0')}`;
                    } else {
                        this.cfListDatepickers.querySelector('input[data-name="end"]').value = '';
                    }
                    this.cfListDatepickers.querySelector('input[data-name="start"]').dispatchEvent(new Event('change'));
                }
                this.setComboboxDate2();
                this.updateGrid();
                this.close();
                this.firstSelect = false;
                window.dispatchEvent(new CustomEvent('apply-date-filter-selections'));
                window.dispatchEvent(new CustomEvent('update-date-pill', {
                    detail: {
                        addDate: {
                            title: `${this.monthLabels[this.focusDay1.getMonth()]} ${this.focusDay1.getDate()} - ${this.monthLabels[this.focusDay2.getMonth()]} ${this.focusDay2.getDate()}`,
                            path: 'date-range'
                        }
                    }
                }));
            }
        }
        event.stopPropagation();
        event.preventDefault();
    }

    // combobox methods
    setComboboxDate(domNode) {
        let d = this.focusDay1;
        if (domNode) {
            d = this.getDayFromDataDateAttribute(domNode);
        }

        this.comboboxNode.textContent = `${this.monthLabels[d.getMonth()]} ${d.getDate()}`;
    }

    setComboboxDate2() {
        if(!this.isSameDay(this.focusDay1, this.focusDay2)) {
            this.comboboxNode.textContent = `${this.monthLabels[this.focusDay1.getMonth()]} ${this.focusDay1.getDate()} - ${this.monthLabels[this.focusDay2.getMonth()]} ${this.focusDay2.getDate()}`;
        }
    }

    // calls an event (to the filter bar component) to update the filters and do a search
    updateFilters = () => {
        const filterValues = this.getFilterValues();

        window.dispatchEvent(new CustomEvent('apply-date-filter-selections', {
            detail: {
                filterableListing: this.elements.filterableListing,
                data: filterValues
            }
        }));
        this.updateFilterBar();
    };
}

// Initialize menu button date picker
registerComponent('.combobox-datepicker', ComboboxDatePicker);

export default ComboboxDatePicker;
